import { Component, OnInit, Inject, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { AuthStoreDispatcher } from 'src/app/core/state/auth/auth.dispatcher';
import { CountdownService } from 'src/app/game/component/top-up/countdown.service';

@Component({
    selector: 'app-confirm-input',
    templateUrl: './confirm-input.component.html',
    styleUrls: ['./confirm-input.component.scss'],
    providers: [CountdownService],
    standalone: false
})
export class ConfirmInputComponent implements OnInit, OnDestroy {
    title: string;
    body: string;
    cancelText: string;
    okText: string;
    countdownSubscription: Subscription;
    warning;
    cancelButtonClass = '';
    bolderBody = '';

    constructor(
        private dialogRef: MatDialogRef < ConfirmInputComponent > ,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private countdownService: CountdownService,
        private authDispatcher: AuthStoreDispatcher,
    ) {
        this.title = data.title;
        this.body = data.body;
        this.cancelText = data.cancelText;
        this.okText = data.okText;
        this.warning = data.warning;
        this.cancelButtonClass = data.cancelButtonClass;
        this.bolderBody = data.bolderBody;
    }

    ngOnInit() {
        if (this.data.cancelAfter > 0) {
            this.countdownSubscription = this.countdownService.countdown().subscribe({
                complete: () => {
                    this.countdownService.stop();
                    this.cancel();
                }
            });
            this.countdownService.start(this.data.cancelAfter);
        }
    }

    async dontShow(event) {
        const myId = await this.authDispatcher.getMyID();
        const itemKey = `dontShowAgain_${this.data.dontShowAgain}_${myId}`;
        if (event.detail.checked) {
            localStorage.setItem(itemKey,'true');
        } else {
            localStorage.removeItem(itemKey);
        }
    }

    confirm() {
        this.dialogRef.close({ confirmed: true });
    }

    cancel() {
        this.dialogRef.close({ confirmed: false })
    }

    ngOnDestroy(): void {
        if (this.countdownSubscription) this.countdownSubscription.unsubscribe();
    }
}
